/** Staff session helpers (from localStorage `airotrack_staff`). */

export function getStaffFromStorage() {
	try {
		const raw = localStorage.getItem("airotrack_staff");
		return raw ? JSON.parse(raw) : null;
	} catch {
		return null;
	}
}

export function getStaffRoleId() {
	const staff = getStaffFromStorage();
	const roleId = staff?.role_id;
	return roleId != null && roleId !== "" ? Number(roleId) : null;
}

/** Revoke actions are limited to staff admin (13) and operational admin (6). */
export function canRevoke() {
	const roleId = getStaffRoleId();
	return roleId === 13 || roleId === 6;
}

/** Update renewal data is limited to staff admin (13) and operational admin (6). */
export function canUpdateRenewalData() {
	const roleId = getStaffRoleId();
	return roleId === 13 || roleId === 6;
}
